import type { CartLine, StorefrontVariant } from "../types";

const key = "tit-cart-v1";

export function loadCart(): CartLine[] {
  try {
    const value = JSON.parse(localStorage.getItem(key) || "[]") as CartLine[];
    return Array.isArray(value) ? value.filter((line) => line?.product?.id && Number.isInteger(line.quantity) && line.quantity > 0) : [];
  } catch { return []; }
}

export function persistCart(lines: CartLine[]): void { localStorage.setItem(key, JSON.stringify(lines)); }

export function addToCart(lines: CartLine[], product: StorefrontVariant): CartLine[] {
  const existing = lines.find((line) => line.product.id === product.id);
  return existing
    ? lines.map((line) => line.product.id === product.id ? { ...line, quantity: line.quantity + 1 } : line)
    : [...lines, { product, quantity: 1 }];
}

export function updateCart(lines: CartLine[], productId: string, quantity: number): CartLine[] {
  return quantity < 1 ? lines.filter((line) => line.product.id !== productId) : lines.map((line) => line.product.id === productId ? { ...line, quantity } : line);
}

export function cartSubtotal(lines: CartLine[]): number { return lines.reduce((sum, line) => sum + line.product.price * line.quantity, 0); }

export function shippingFor(subtotal: number, freeShippingThreshold: number, underThresholdShipping: number | null): number | null {
  if (subtotal === 0) return 0;
  if (subtotal >= freeShippingThreshold) return 0;
  return underThresholdShipping;
}
